
import AuthService from '../login/auth.service'
import axios from 'axios'

import { compromisoSocio, cuentas, consultasAPI, tarjetas, creditos, ruedas, solicitudes } from "../../components/generico/utils/UrlAPI";
import authService from '../login/auth.service';
import md5 from 'md5';

let datosSocio = JSON.parse(sessionStorage.getItem('socio'));

class resumenSocioService {
  /**
   * aportes del socio
   * @param {*} canal 
   * @param {*} ejercicio 
   */
  async getAporteSocio(canal, ejercicio) {
    const options = {
      method: "get",
      url: compromisoSocio + "aporte?canal=" + canal + "&anhoEjercicio=" + ejercicio,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };
    return await axios(options)

  };
  /**
   * Solidaridad del socio
   * @param {*} canal 
   * @param {*} ejercicio 
   */
  async getSolidaridadSocio(canal, ejercicio) {
    const options = {
      method: "get",
      url: compromisoSocio + "solidaridad?canal=" + canal + "&anhoEjercicio=" + ejercicio,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },

    };
    return await axios(options)
  };

  /**
   * Ahorro a la vista Socios
   * @param {*} canal 
   */
  async getAHVistaSocio(canal) {
    var data = JSON.stringify({
      canal: canal,

    });
    const options = {
      method: "post",
      url: cuentas + "resumen/ahorros",
      // url: "http://10.10.203.146/cu24-cuentas/api/v2/resumen/ahorros",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
        "Access-Control-Allow-Headers": "X-Requested-With, content-type"
      },
      data: data,
    };
    //  console.log(options)
    return await axios(options)

  };
  /**
   * Ahorros Programados
   * @param {*} canal 
   */
  async getAHProgramadoSocio(canal) {
    var data = JSON.stringify({
      canal: canal,

    });
    const options = {
      method: "post",
      url: cuentas + "resumen/ahorros-programados",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };

    return await axios(options)

  };


  async validarPin(pinTransaccional) {

    var data = JSON.stringify({
      idPersona: authService.getSocio().idPersona,
      pinTransaccional: md5(pinTransaccional)
    });

    const options = {
      method: "post",
      url: cuentas + "socio-cuenta/verificar-pin",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
        "Access-Control-Allow-Headers": "X-Requested-With, content-type"
      },
      data: data
    };
    //  console.log(options)
    return await axios(options)

  };


  /**
   * Rueda Gigante
   * @param {*} canal 
   */
  async getRuedaGiganteSocio(canal) {
    var data = JSON.stringify({
      canal: canal,

    });
    const options = {
      method: "post",
      //url: cuentas + "resumen/ahorros-ruedas",
      url: cuentas + "resumen/ahorros-ruedas",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };

    return await axios(options)

  };
  /**
   * Ahorro a Plazo Fijo
   * @param {*} canal 
   */
  async getAHPlazosFijosSocio(canal) {
    var data = JSON.stringify({
      canal: canal,

    });
    const options = {
      method: "post",
      url: cuentas + "resumen/ahorros-plazos-fijos",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };

    return await axios(options)

  };
  
  /**
   * Obtener cotizaciones
   * @param {*} canal 
   */
  async getCotizaciones(canal) {
    var data = JSON.stringify({
      canal: canal,

    });
    const options = {
      method: "post",
      url: consultasAPI + "cotizaciones",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };

    return await axios(options)

  };

  /**
   * Obtener datos de las tarjetas del socio
   * @param {*} canal 
   */
  async getTarjetas(canal) {

    const options = {
      method: "get",
      url: tarjetas + "tarjeta?canal=" + canal,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },

    };

    return await axios(options)

  };

  async getPromoTarjeta(canal) {

    const options = {
      method: "get",
      //url: tarjetas + "tarjeta/promo-tarjeta/?canal=" + canal,
      url: tarjetas + "tarjeta/promo-tarjeta/?canal=" + canal,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },

    };

    return await axios(options)

  };

  async getPrestamos(canal) {
    var data = JSON.stringify({
      canal: canal,

    });
    const options = {
      method: "post",
      url: creditos + "creditos/resumen",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };

    return await axios(options)

  };

  async getPrestamosSolicitados(canal) {
    var data = JSON.stringify({
      canal: canal,

    });
    const options = {
      method: "post",
      url: creditos + "creditos/resumen/creditos-solicitados",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };

    return await axios(options)

  };

  async cuotasPrestamo(credito, modo) {
    var data = JSON.stringify({
      idCredito: credito,
      modo: modo,
      canal: "WEB",
    });

    var config = {
      method: "post",
      url: creditos + "creditos/cuotas",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    //  console.log(data)
    return await axios(config);
  }

  /*************************
   * SOLICITUDES SUBSIDIOS *
   *************************/
  async getSolicitudesSubsidios() {
    let config = {
      method: "get",
      url: solicitudes + datosSocio.idPersona,
      //url: solicitudes + "553948",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };
    return await axios(config);

  };

  async getArchivosRechazadosSubsidio(idSubsidio) {
    let config = {
      method: "get",
      url: solicitudes + "obtenerSubsidioRechazados/" + idSubsidio,
      // url: "http://localhost:8080/obtenerSubsidioRechazados/" + idSubsidio,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
    };
    return await axios(config);

  };

  async detalleAH(cuenta, fecha, tipo) {

    var data = JSON.stringify({
      canal: "WEB",
      fecha: fecha,
      cuenta: cuenta,
      tipoCuenta: tipo,

    });

    var config = {
      method: "post",
      url: cuentas + "movimiento/ahorros",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    ///  console.log(data)
    return await axios(config);
  }

  async detalleRueda(canal, cuenta, grupo, plan) {
    var data = JSON.stringify({
      canal: canal,
      cuenta: cuenta,
      grupo: grupo,
      plan: plan,
    });

    var config = {
      method: "post",
      url: ruedas + "cuotas/detalles",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    // console.log(data)
    return await axios(config);
  }

  async detalleTC(nroTC, canal) {

    var data = JSON.stringify({
      canal: canal,
      numeroTarjeta: nroTC,

    });

    var config = {
      method: "post",
      url: tarjetas + "extractos/panal-cabal",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data: data,
    };
    ///  console.log(data)
    return await axios(config);
  }

  async descagarExtractoGeneral() {

    var _url = cuentas + "socio-cuenta/get-extracto-general";
    var config = {
      method: "get",
      url: _url,
      responseType: "blob",
      headers: {
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      }
    };
    return await axios(config);

  }

  async modificarEtiqueta(body) {

    let _url = cuentas + "socio-cuenta/etiqueta";
    let config = {
      method: "post",
      url: _url,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AuthService.getCurrentToken(),
      },
      data : body
    };
    return await axios(config);

  }

  async getPrestamosCuotasEditables(data) {
    const url = `${creditos}creditos/listar-creditos-cambio-vencimiento`
    const config = {
      method : 'post',
      url,
      headers:{
        "Content-Type": "application/json",
        Authorization: `Bearer ${AuthService.getCurrentToken()}`
      },
      data
    }
    return await axios(config);
  }

}
export default new resumenSocioService();